/**
 * A rate as the operator types and reads it: "2.7" percent is 27000 millionths.
 *
 * Millionths because every rate in the payroll calculation is held that way
 * (migrations 0032 and 0034), and exactly: no float touches the digits, for the
 * reason money.ts gives for parseCents. Up to four decimal places of a percent,
 * which is one millionth.
 */

/** "2.7", "2.7%" or ".5" to millionths; null for anything else, a blank or 100% and up included. */
export function parseRateMillionths(text: string): number | null {
  const cleaned = text.trim().replace(/[%\s]/g, '');
  if (!/^(?:\d{1,6}(?:\.\d{0,4})?|\.\d{1,4})$/.test(cleaned)) return null;
  const [whole, fraction = ''] = cleaned.split('.');
  const millionths = Number(whole || '0') * 10_000 + Number(fraction.padEnd(4, '0'));
  return millionths < 1_000_000 ? millionths : null;
}

/** 27000 millionths is "2.7%". */
export function formatRateMillionths(millionths: number): string {
  const whole = Math.floor(millionths / 10_000);
  const fraction = String(millionths % 10_000)
    .padStart(4, '0')
    .replace(/0+$/, '');
  return `${whole}${fraction ? `.${fraction}` : ''}%`;
}
